import React, { useEffect, useRef } from 'react'
import MUIButton from '../../Components/Shared/MUI-Button'
import { Add } from '@mui/icons-material'
import useInViewport from '../../Hooks/useInViewPort'

interface FloatingAddButtonProps {
  label: string
  onClick: () => void
  disabled: boolean
  width?: number
  size?: 'small' | 'medium' | 'large'
  variant?: 'contained' | 'outlined'
  setShowSecondaryCta?: (value: boolean) => void
  testID?: string
}

const FloatingAddButton: React.FC<FloatingAddButtonProps> = ({
  label,
  onClick,
  disabled,
  width = 120,
  size = 'large',
  variant = 'contained',
  setShowSecondaryCta,
  testID,
}) => {
  const buttonRef = useRef<HTMLDivElement>(null)

  const isInViewport = useInViewport(buttonRef, { rootMargin: '-120px  0px -70px 0px' })

  useEffect(() => {
    setShowSecondaryCta?.(!isInViewport)
  }, [isInViewport])
  return (
    <div ref={buttonRef}>
      <MUIButton
        size={size}
        type='button'
        label={label}
        variant={variant}
        width={width}
        className='add-asset-btn'
        disabled={disabled}
        handleClickCB={onClick}
        startIcon={<Add />}
        testID={testID}
      />
    </div>
  )
}

export default FloatingAddButton
